import React, { useState, useEffect } from "react";
import { useAuth } from "../auth/AuthContext";
import MonoButton from "./MonoButton";

const UpdateUserProfileModal = ({ initialData = {}, onSuccess }) => {
  const { userId } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    firstName: "",
    email: "",
    postalCode:"",
    address: "",
    city: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState(""); // ✅ Eigene State-Variable für Fehler

  const fetchUserData = async () => {
    try {
      const res = await fetch(
        "https://www.denisbitter.de/stage01/api/get_user_profile.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: Number(userId) }), // id als Zahl senden
        }
      );

      const data = await res.json();
      console.log("API response:", data);

      if (data.success) {
        setFormData(data.data);
        setError(""); // Fehler zurücksetzen
      } else {
        setError("Fehler beim Laden der Daten: " + data.message);
      }
    } catch (err) {
      // 1. Fehlerhaften JSX-Code aus dem catch-Block entfernt
      setError("Fehler beim Laden der Daten.");
      console.error(err);
    }
  };



  // Button beenden einblenden 

  const [isSaved, setIsSaved] = useState(false);


  // Beim Öffnen des Modals Nutzerdaten laden
  useEffect(() => {
    if (isOpen) {
      fetchUserData();
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    try {
      console.log("Sende Anfrage mit userId:", userId);
      const res = await fetch(
        "https://www.denisbitter.de/stage01/api/update_user_profile.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, id: Number(userId) }), // id statt userId senden
        }
      );

      const data = await res.json();
          if (data.success) {
            setError(""); // Fehler zurücksetzen
            setMessage(data.message || "Aktualisiert.");
            setIsSaved(true); // Speichern erfolgreich

            if (onSuccess) onSuccess();

            // Optional automatisch schließen:
            setTimeout(() => {
              setIsOpen(false);
              setMessage(""); // Nachricht nach dem Schließen zurücksetzen
            }, 1500);
          } else {
            setError(data.message || "Fehler beim Speichern.");
          }
    } catch (err) {
      setError("Fehler beim Speichern.");
      console.error(err);
    }
  };

  return (
    <>
      <div className="text-left">
        <button
          className="underline text-xs text-gray-600 mt-2"
          onClick={() => setIsOpen(true)}
        >
          Kontaktdaten ändern
        </button>
      </div>
      {isOpen && (
        <div className="fixed inset-0  bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 shadow-lg w-full max-w-md font-mono text-xs">
            <h2 className="text-xs font-bold mb-4 text-left">
              Benutzerdaten ändern
            </h2>

            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className="border px-4 py-2 rounded w-full mb- text-xs"
              placeholder="Vorname"
            />
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="border mt-2 px-4 py-2 rounded w-full  text-xs"
              placeholder="Nachname"
            />
            <input
              type="text"
              name="address"
              value={formData.address}
              onChange={handleChange}
              className="border mt-2 px-4 py-2 rounded w-full text-xs"
              placeholder="Straße"
            />

                 <input
              type="text"
              name="postalcode"
              value={formData.postalCode}
              onChange={handleChange}
              className="border mt-2 px-4 py-2 rounded w-full text-xs"
              placeholder="PLZ"
            />
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className="border mt-2 px-4 py-2 rounded w-full text-xs"
              placeholder="Stadt"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="border mt-2 px-4 py-2 rounded w-full text-xs"
              placeholder="E-Mail"
            />
         

            <MonoButton className="w-full mt-2" onClick={handleSave}>
              Speichern
            </MonoButton>
            {message && (
              <p className="text-sm mt-2 text-green-600 break-words">{message}</p>
            )}
            {/* 2. Eigener Absatz für die Fehlermeldung mit roten Textklassen */}
            {error && (
              <p className="mt-2 text-red-500 text-sm font-bold font-mono justify-center text-center">
                {error}
              </p>
            )}
            <button
              className="mt-2 text-xs text-gray-400 underline w-full"
              onClick={() => setIsOpen(false)}
            >
              Abbrechen
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UpdateUserProfileModal;
